import { useCallback } from 'react'
import { GridApi, ProcessCellForExportParams } from 'ag-grid-community'
import { exportExcel } from '../../../containers/BulkSheet/excel'
import { useDialogState } from '../../../components/dialogs/useDialogState'

// `in` 演算子で narrow した上で型を絞り込むためのヘルパー。
// 値が object かつ指定キーを持ち、その値が string であれば真。
const hasStringProp = <K extends string>(
  value: object,
  key: K
): value is { [P in K]: string } =>
  key in value && typeof (value as Record<string, unknown>)[key] === 'string'

// SprintReport の Excel 出力。
// 各セルは valueGetter で算出済み (数値・サマリーラベル '-' 等) なのでデフォルト処理で扱えるが、
// 集計セル等で cell.value が object になっているケースを保険として name/displayName で文字列化する。
const customExportValues = (
  params: ProcessCellForExportParams
): string | number | undefined => {
  const value: unknown = params.value
  if (value === null || typeof value !== 'object') return undefined
  if (hasStringProp(value, 'name')) return value.name
  if (hasStringProp(value, 'displayName')) return value.displayName
  return undefined
}

export const useSprintReportExcel = (gridApi: GridApi | null) => {
  const [dialogOpen, openDialog, closeDialog] = useDialogState()

  const onExportExcel = useCallback(
    (colIds: string[]) => {
      if (!colIds || colIds.length === 0 || !gridApi) return
      exportExcel({
        fileNamePrefix: 'sprint_report',
        gridApi,
        exportColIds: colIds,
        shouldRowBeSkipped: params =>
          !params.node.data || !params.node.displayed,
        getCustomExportValue: customExportValues,
      })
      closeDialog()
    },
    [gridApi, closeDialog]
  )

  return {
    dialogOpen,
    openDialog,
    closeDialog,
    onExportExcel,
  }
}
